import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff4f09c8")

_pushScopeId("data-v-ff4f09c8")
const _hoisted_1 = { class: "table" }
const _hoisted_2 = {
  key: 0,
  class: "table__body table__body--empty"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }),
  /*#__PURE__*/_createTextVNode("Chargement...")
], -1)
const _hoisted_4 = {
  key: 1,
  class: "listState"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "table__header row__wrapper row" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"header__cell cell cell--info cell--data\" data-v-ff4f09c8><span data-v-ff4f09c8><i class=\"icon-calendar\" data-v-ff4f09c8></i> Information </span></div><div class=\"header__cell cell cell--date cell--data\" data-v-ff4f09c8><span data-v-ff4f09c8><i class=\"icon-calendar\" data-v-ff4f09c8></i> Date </span></div><div class=\"header__cell cell cell--time cell--data\" data-v-ff4f09c8><span data-v-ff4f09c8><i class=\"icon-clock\" data-v-ff4f09c8></i> Heure </span></div><div class=\"header__cell cell cell--field cell--data\" data-v-ff4f09c8><span data-v-ff4f09c8><i class=\"icon-location\" data-v-ff4f09c8></i> Terrain </span></div><div class=\"header__cell cell cell--available cell--data\" data-v-ff4f09c8><span data-v-ff4f09c8>Disponibilité</span></div><div class=\"header__cell cell cell--selected\" data-v-ff4f09c8></div><div class=\"header__cell cell cell--selected cell--data\" data-v-ff4f09c8></div>", 7)
const _hoisted_15 = {
  key: 0,
  class: "header__cell cell cell--selected cell--data"
}
const _hoisted_16 = {
  ref: "timeslots",
  class: "table_body"
}
const _hoisted_17 = { class: "cell cell--info cell--data" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "icon-clock" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_20 = { class: "cell cell--date cell--data" }
const _hoisted_21 = { class: "cell cell--time cell--data" }
const _hoisted_22 = { class: "cell cell--field cell--data" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "icon-location" }, null, -1)
const _hoisted_24 = { class: "cell cell--available cell--data" }
const _hoisted_25 = { class: "cell cell--reservation " }
const _hoisted_26 = {
  key: 0,
  class: "action--icon"
}
const _hoisted_27 = {
  key: 1,
  class: "action--icon"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "cell cell--selected cell--data" }
const _hoisted_30 = {
  key: 0,
  class: "cell cell--selected cell--data"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ConfirmAction = _resolveComponent("ConfirmAction")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.timeslotsLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : (_ctx.noFutureTimeslots)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("span", null, [
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.noDataText), 1)
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock("div", _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_16, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.futureTimeslots, (timeslot, ix) => {
                return (_openBlock(), _createBlock("div", {
                  key: timeslot._id,
                  class: "row__wrapper row"
                }, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("span", null, _toDisplayString(_ctx.formattedDate(timeslot.date)), 1),
                    _createVNode("span", null, [
                      _hoisted_18,
                      _createTextVNode(_toDisplayString(_ctx.formattedTime(timeslot.date)), 1)
                    ]),
                    _createVNode("span", null, [
                      _createVNode(_component_router_link, {
                        to: `/fields#${encodeURI(timeslot.field)}`
                      }, {
                        default: _withId(() => [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(timeslot.field), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("span", null, _toDisplayString(_ctx.formattedDate(timeslot.date)), 1)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("span", null, _toDisplayString(_ctx.formattedTime(timeslot.date)), 1)
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("span", null, [
                      _createVNode(_component_router_link, {
                        to: `/fields#${encodeURI(timeslot.field)}`
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(timeslot.field) + " ", 1),
                          _hoisted_23
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", {
                      class: {
                            'green--text': !timeslot.reservation && !timeslot.pendingApproval,
                            'yellow--text': timeslot.pendingApproval && timeslot.reservation,
                            'red--text': !timeslot.pendingApproval && timeslot.reservation,
                            'grey--text': _ctx.isWaitingOnConfirmation(timeslot) 
                        }
                    }, [
                      _createVNode("i", {
                        class: {
                                    'icon-select2':  !timeslot.reservation && !timeslot.pendingApproval,
                                    'icon-attention': timeslot.pendingApproval && timeslot.reservation,
                                    'icon-cancel': !timeslot.pendingApproval && timeslot.reservation,
                                    'icon-info-circled': _ctx.isWaitingOnConfirmation(timeslot) 
                                },
                        title: _ctx.requestPendingStr(timeslot)
                      }, null, 10, ["title"])
                    ], 2)
                  ]),
                  _createVNode("div", _hoisted_25, [
                    (_ctx.canConfirmReservation(timeslot))
                      ? (_openBlock(), _createBlock("i", _hoisted_26, [
                          _createVNode(_component_ConfirmAction, {
                            type: "ts-confirm",
                            onConfirm: ($event: any) => (_ctx.confirmReservation(timeslot))
                          }, null, 8, ["onConfirm"]),
                          _createVNode(_component_ConfirmAction, {
                            type: "ts-deny",
                            onConfirm: ($event: any) => (_ctx.denyReservation(timeslot))
                          }, null, 8, ["onConfirm"])
                        ]))
                      : (_ctx.canApproveReservation(timeslot))
                        ? (_openBlock(), _createBlock("i", _hoisted_27, [
                            _createVNode(_component_ConfirmAction, {
                              type: "custom",
                              behavior: "confirm",
                              icon: "icon-calendar-tick",
                              msg: _ctx.isWaitingOnConfirmation(timeslot) || !_ctx.hasReservation(timeslot)? 'Approuver sans la confirmation des captaines': 'Approuver la réservation',
                              onConfirm: ($event: any) => (_ctx.approveReservation(timeslot))
                            }, null, 8, ["msg", "onConfirm"]),
                            (_ctx.hasReservation(timeslot))
                              ? (_openBlock(), _createBlock("i", _hoisted_28, [
                                  _createVNode(_component_ConfirmAction, {
                                    type: "custom",
                                    behavior: "reject",
                                    icon: "icon-calendar-cancel",
                                    msg: "Refuser la requete de réservation",
                                    onConfirm: ($event: any) => (_ctx.denyReservation(timeslot))
                                  }, null, 8, ["onConfirm"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_29, [
                    (_ctx.canSelectTimeslot(timeslot))
                      ? (_openBlock(), _createBlock(_component_ConfirmAction, {
                          key: 0,
                          type: "ts-select",
                          onConfirm: ($event: any) => (_ctx.selectAvailableTimeslot(ix))
                        }, null, 8, ["onConfirm"]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isAdmin)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        _createVNode(_component_ConfirmAction, {
                          type: "delete",
                          onConfirm: ($event: any) => (_ctx.removeTimeslot(timeslot._id))
                        }, null, 8, ["onConfirm"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 512)
          ]))
  ]))
})